/*************************
 *
 *  Alter Path for chunks
 *
 *********************** */
const url = new URL(document.currentScript.src);
__webpack_public_path__ = url.href.substring(0, url.href.lastIndexOf('/') - 2);

/*************************
 *
 *  jQuery
 *
 *********************** */
if (typeof jQuery !== 'undefined') {
	window.$ = window.jQuery = $ = jQuery.noConflict();
}

/*************************
 *
 *  Load modules
 *
 *********************** */
function importAll(r) {
	r.keys().forEach(r);
}
importAll(require.context('./modules/', true, /(.*)\.loader\.js$/));

/*************************
 *
 *  Theme JS
 *
 *********************** */

$(document).on('ready', function () {
	$('.hamburger').on('click', function () {
		$('.hamburger #nav-icon4').toggleClass('open');
		$('.links').slideToggle();
	});

	let navLogic = () => {
		if ($(window).width() <= 992) {
			// $('.links .menu-item-has-children a').click(function (e) {
			// 	e.stopPropagation();
			// 	var href = e.currentTarget.getAttribute('href');
			// 	window.location = href;
			// });
			$('.links .menu-item-has-children').click(function (e) {
				console.log('mobile nav parent triggered');
				e.preventDefault();
				e.stopPropagation();
				$(this).toggleClass('open-menu');
				$(this).children('.sub-menu:first').stop(true).slideToggle();
			});
			$('.links .menu-item-has-children .sub-menu a').click(function (e) {
				var href = e.currentTarget.getAttribute('href');
				window.location = href;
			});
			$('.no-click-link > a:first').on('click', function (e) {
				e.stopPropagation();
				e.preventDefault();
				return false;
			});
		}
	};

	navLogic();

	setTimeout(() => {
		jQuery('form .field .input input').focus(function () {
			jQuery(this).parent().siblings('label').addClass('has-focus');
		});

		jQuery('form .field .input input').focusout(function () {
			var text_val = jQuery(this).val();
			if (text_val === '') {
				jQuery(this).removeClass('has-focus');
				jQuery(this).parent().siblings('label').removeClass('has-focus');
			} else {
				jQuery(this).addClass('has-focus');
				jQuery(this).parent().siblings('label').addClass('has-focus');
			}
		});

		jQuery('form .field .input textarea').focus(function () {
			jQuery(this).parent().siblings('label').addClass('has-focus');
		});
		jQuery('form .field .input textarea').focusout(function () {
			var text_val = jQuery(this).val();
			if (text_val === '') {
				jQuery(this).removeClass('has-focus');
				jQuery(this).parent().siblings('label').removeClass('has-focus');
			} else {
				jQuery(this).addClass('has-focus');
				jQuery(this).parent().siblings('label').addClass('has-focus');
			}
		});
	}, 500);

	let stickyNavLoggedIn = () => {
		if (document.getElementById('wpadminbar')) {
			var adminbarHeight = document.getElementById('wpadminbar').offsetHeight;
			if (window.innerWidth >= 782) {
				document.querySelector('#header').style.top = adminbarHeight + 'px';
			} else if (window.innerWidth < 781 && window.innerWidth > 600) {
				document.querySelector('#header').style.top = adminbarHeight + 'px';
			} else if (window.innerWidth <= 599 && window.innerWidth > 576) {
				document.querySelector('#header').style.top = 0 + 'px';
			}
		}
	};
	stickyNavLoggedIn();

	$(window).on('resize', function () {
		// ();navLogic
		stickyNavLoggedIn();
	});

	$('.open-close.fixed-pw').on('click', function () {
		$('.popup-container').addClass('show');
	});
	$('.open-close.inner-close-btn').on('click', function () {
		$('.popup-container').removeClass('show');
	});
	$('.close').on('click', function () {
		$('.popup-container').removeClass('show');
	});

	function animation(param) {
		let req;
		let init = null;
		let time;
		let result;
		const start = param.start;
		const end = param.end;
		const duration = 2000;
		const easing = (t, b, c, d) => (c * t) / d + b; //linear

		const startAnim = (timeStamp) => {
			init = timeStamp;
			draw(timeStamp);
		};

		const draw = (now) => {
			time = now - init;
			result = easing(time, start, end - start, duration);
			param.onChange(result >= end ? end : result);
			req = window.requestAnimationFrame(draw);
			time >= duration && window.cancelAnimationFrame(req);
		};

		req = window.requestAnimationFrame(startAnim);
	}

	const pageContainer = document.querySelector('.entry-content');
	const childrenArray = Array.from(pageContainer.children);

	// Create a new waypoint for each card
	for (let i = 0; i < childrenArray.length; i++) {
		let itemChild = childrenArray[i];
		if (
			itemChild.classList.contains('no-animate') ||
			itemChild.classList.contains('hero') ||
			itemChild.classList.contains('trust') ||
			itemChild.classList.contains('hero-options') ||
			itemChild.classList.contains('case-study-heade')
		) {
			console.log('hero, page-hero, trust');
		} else {
			itemChild.classList.add('animate__animated', 'animate__hidden');

			new Waypoint({
				element: itemChild,
				handler: function (direction) {
					if (direction === 'down') {
						if (itemChild.classList.contains('animate__hidden')) {
							itemChild.classList.remove('animate__hidden');
							itemChild.classList.add('animate__fadeInUp');
						}
					} else {
						itemChild.classList.remove('animate__fadeInUp');
					}
				},
				offset: '75%',
			});
		}
	}

	var metrics = document.querySelectorAll('.metrics');
	var fullWidthMetric = document.querySelectorAll('.full-width-metric');

	metrics.forEach(function (item) {
		new Waypoint({
			element: item,
			handler: function (direction) {
				if (direction === 'down') {
					if (item.classList.contains('animate__hidden')) {
						item.classList.remove('animate__hidden');
						item.classList.add('animate__fadeInUp');
					}
				} else {
					item.classList.remove('animate__fadeInUp');
				}
				if (item.classList.contains('animate__fadeInUp')) {
					item.querySelectorAll('.metric-cards .metric.percentage').forEach(function (metric) {
						animation({
							start: 0,
							end: metric.querySelector('.value-container').textContent.replace('%', ''),
							onChange(value) {
								metric.querySelector('.value-container').textContent = Math.round(value) + '%';
							},
						});
						const circularProgress = metric.querySelector('.circular-progress');
						const style = getComputedStyle(circularProgress);
						const valueProgress = style.getPropertyValue('--value').replace('%', '');

						animation({
							start: 0,
							end: valueProgress,
							onChange(value) {
								// circularProgress.textContent = Math.round(value) + '%';
								circularProgress.style.setProperty('--value', Math.round(value) + '%');
							},
						});
					});
				}
			},
			offset: '75%',
		});
	});

	fullWidthMetric.forEach(function (item) {
		new Waypoint({
			element: item,
			handler: function (direction) {
				if (direction === 'down') {
					if (item.classList.contains('animate__hidden')) {
						item.classList.remove('animate__hidden');
						item.classList.add('animate__fadeInUp');
					}
				} else {
					item.classList.remove('animate__fadeInUp');
				}
				if (item.classList.contains('animate__fadeInUp')) {
					item.querySelectorAll('.metric').forEach(function (metric) {
						animation({
							start: 0,
							end: metric.querySelector('.value-container').textContent.replace('%', ''),
							onChange(value) {
								metric.querySelector('.value-container').textContent = Math.round(value) + '%';
							},
						});
						const circularProgress = metric.querySelector('.circular-progress');
						const style = getComputedStyle(circularProgress);
						const valueProgress = style.getPropertyValue('--value').replace('%', '');

						animation({
							start: 0,
							end: valueProgress,
							onChange(value) {
								// circularProgress.textContent = Math.round(value) + '%';
								circularProgress.style.setProperty('--value', Math.round(value) + '%');
							},
						});
					});
				}
			},
			offset: '75%',
		});
	});
});

//Video playing
$(document).ready(function () {
	$('.video-block__image').on('click', function () {
		var videoEmbed = $(this).next('.video-block__embed');
		var url = videoEmbed.data('url');
		var width = $(this).width();
		var height = $(this).height();

		$(this).fadeOut('fast', function () {
			videoEmbed
				.html(
					'<iframe src="' +
						url +
						'&width=' +
						width +
						'&height=' +
						height +
						'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
				)
				.fadeIn('fast');
		});
	});
});


//hubspot required fields only shown after submit
$(document).ready(function () {
	// Get the submit button
	var submitButton = $('form .hs_submit.hs-submit input');

	// Add an event listener to the submit button
	submitButton.on('click', function () {
		// Hide all error messages
		$('.hs-error-msg').hide();

		// Check if all required fields are filled out
		var allFieldsFilledOut = true;

		// Loop through all of the required fields
		$('.required').each(function () {
			// If a required field is empty
			if ($(this).val() == '') {
				// Set the flag to false
				allFieldsFilledOut = false;

				// Show the error message
				$(this).next('.hs-error-msg').show();
			}
		});

		// If all required fields are filled out
		if (allFieldsFilledOut) {
			// Submit the form
			submitButton.closest('form').submit();
		}
	});
});

$(document).ready(function () {
	const serviceCards = document.querySelectorAll('a.service-card'); // Select all <a> tags with class "service-card"
	let counter = 0; // Initialize a counter variable
	while (counter < serviceCards.length) {
		// Loop through all service cards
		const hrefValue = serviceCards[counter].getAttribute('href'); // Get the value of the "href" attribute
		if (hrefValue === '#no-hover') {
			// If the href value is "no-hover"
			const idValue = 'no-hover'; // Set the ID value to "no-hover"
			serviceCards[counter].setAttribute('id', idValue); // Set the "id" attribute to the ID value
		}
		counter++; // Increment the counter variable
	}
});
